// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTimeline-List_cls1__hRb5V","cls2":"VeloTimeline-List_cls2__F3FaN VeloTimeline-List_cls1__hRb5V"};